import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const GetAllSevenDaysAppointments = (payload: any) => {
    return ApiService[APIConfig.GET_ALL_7_APPOINTMENTS.METHOD](APIConfig.GET_ALL_7_APPOINTMENTS.URL, payload);
}

const GetAllAppointments = (payload: any) => {
    return ApiService[APIConfig.GET_ALL_APPOINTMENTS.METHOD](APIConfig.GET_ALL_APPOINTMENTS.URL, payload);
}
const GetScheduledAndOutstandingBalanceCount = () => {
    return ApiService[APIConfig.GET_SCHEDULED_OUTSTANDING_AMOUNT_COUNT.METHOD](APIConfig.GET_SCHEDULED_OUTSTANDING_AMOUNT_COUNT.URL);
}

const GetAllAlertsDetails = (payload: any) => {
    return ApiService[APIConfig.GET_ALL_ALERTS_DETAILS.METHOD](APIConfig.GET_ALL_ALERTS_DETAILS.URL, payload);
}

const WaiverAndReleaseForm = (id:string,payload: any) => {
    return ApiService[APIConfig.WAIVER_RELEASE_FORM.METHOD](APIConfig.WAIVER_RELEASE_FORM.URL(id), payload);
}
const AddWaiverAndReleaseForm = (payload: any,) => {
    return ApiService[APIConfig.ADD_WAIVER_RELEASE_FORM.METHOD](APIConfig.ADD_WAIVER_RELEASE_FORM.URL, payload);
}
const AuthCasesList = (payload: any) => {
    return ApiService[APIConfig.AUTHORIZATION_CASES_LIST.METHOD](APIConfig.AUTHORIZATION_CASES_LIST.URL, payload);
}
const AddAuthorisationToDiscloseInfo = (payload: any) => {
    return ApiService[APIConfig.ADD_AUTHORISATION_TO_DISCLOSE_INFORMATION.METHOD](APIConfig.ADD_AUTHORISATION_TO_DISCLOSE_INFORMATION.URL, payload);
}
const EditAuthorisationToDiscloseInfo = (appointmentId: string, payload: any) => {
    return ApiService[APIConfig.EDIT_AUTHORISATION_TO_DISCLOSE_INFORMATION.METHOD](APIConfig.EDIT_AUTHORISATION_TO_DISCLOSE_INFORMATION.URL(appointmentId), payload);
}
const GetAuthorisationToDiscloseInfo = (appointmentId: string) => {
    return ApiService[APIConfig.GET_AUTHORISATION_TO_DISCLOSE_INFORMATION_DETAILS.METHOD](APIConfig.GET_AUTHORISATION_TO_DISCLOSE_INFORMATION_DETAILS.URL(appointmentId));
}
const AddAuthorisationToReleaseHealthInfo = (payload: any) => {
    return ApiService[APIConfig.ADD_AUTHORISATION_TO_HEALTH_INFORMATION.METHOD](APIConfig.ADD_AUTHORISATION_TO_HEALTH_INFORMATION.URL, payload);
}
const EditAuthorisationToReleaseHealthInfo = (appointmentId: string, payload: any) => {
    return ApiService[APIConfig.EDIT_AUTHORISATION_TO_HEALTH_INFORMATION.METHOD](APIConfig.EDIT_AUTHORISATION_TO_HEALTH_INFORMATION.URL(appointmentId), payload);
}
const GetAuthorisationToReleaseHealthInfo = (appointmentId: string) => {
    return ApiService[APIConfig.GET_AUTHORISATION_TO_HEALTH_INFORMATION_DETAILS.METHOD](APIConfig.GET_AUTHORISATION_TO_HEALTH_INFORMATION_DETAILS.URL(appointmentId));
}


const DashboardService = {
    GetAllSevenDaysAppointments,
    GetAllAppointments,
    GetScheduledAndOutstandingBalanceCount,
    GetAllAlertsDetails,
    WaiverAndReleaseForm,
    AuthCasesList,
    AddAuthorisationToDiscloseInfo,
    GetAuthorisationToDiscloseInfo,
    AddAuthorisationToReleaseHealthInfo,
    EditAuthorisationToReleaseHealthInfo,
    GetAuthorisationToReleaseHealthInfo,
    AddWaiverAndReleaseForm,
    EditAuthorisationToDiscloseInfo
}

export default DashboardService;
